(() => {
  let opener;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-bs-legal-notice]');
    const dialog = document.getElementById('bs-legal-notice-dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      opener = link;
      const image = dialog.querySelector('[data-bs-legal-image]');
      if (!image.getAttribute('src')) image.src = image.dataset.src;
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('bs-legal-notice-open');
    } else if (event.target.closest('[data-bs-legal-close]')) {
      dialog.close();
    } else if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  document.addEventListener('close', event => {
    if (event.target.id !== 'bs-legal-notice-dialog') return;
    document.documentElement.classList.remove('bs-legal-notice-open');
    if (opener?.isConnected) opener.focus();
  }, true);
})();
